import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import actions from '@/app/actions.js';
import { get_index, get_index_recommend } from '../../api/cgi/knowledge';
import { reportUserBehaviorCgi } from '@/api/cgi/common';
import { Badge } from '@tencent/spaui';
import newRecommendPng from '@/assets/images/new-recommend.png';
import { REACT_APP_ROOT_URL } from '@/constants/Constants';
import FooterQrcode from '@/assets/images/ams_wechatfwh.png';
import './bgAnimation.scope.less';

class Home extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hot_word_list: [],
      catalog_list: [],
      hot_post_list: [],
      newRecommendList: [],
    };
  }

  componentDidMount() {
    this.getIndexInfo();
    this.getNewRecommend();
  }
  getNewRecommend = () => {
    const getCookieToken = window.sessionStorage.getItem('knowledge_token');
    get_index_recommend({
      data: {
        knowledge_token: getCookieToken,
        page_size: 6,
      },
    }).then((res) => {
      if (res.code == 0) {
        const newRecommendList = res.data?.list;
        this.setState({
          newRecommendList,
          moreUrl: res.data.more_url,
        });
      }
    });
  }
  getIndexInfo() {
    const dispatch = this.props.dispatch;
    const getCookieToken = window.sessionStorage.getItem('knowledge_token');
    get_index({
      data: {
        knowledge_token: getCookieToken,
      },
    }).then((response) => {
      if (response.code == 0) {
        const obj = response.data || {};
        this.setState({
          hot_word_list: obj.hot_word_list,
          catalog_list: obj.catalog_list,
          hot_post_list: obj.hot_post_list,
        });
      }
    });
  }

  handleSearch = (e, val, data, hotKey = false) => {
    this.setState(
      {
        keyword: val,
      },
      (_) => {
        if (hotKey) {
          this.setState({ hotKeywordPannelShow: false });
          this.toSearch(val);
          this.report(`搜索热词-${val}`);
        }
      },
    );
  }
  handleSearchClear = (e, val) => {
    this.setState({
      keyword: '',
    });
  }
  handleKeyPress = (e, val) => {
    if (e.charCode == 13) {
      this.setState({ keyword: e.target.value, hotKeywordPannelShow: false });
      this.toSearch(e.target.value);
    }
  }
  toSearch = (keyword) => {
    this.props.dispatch({
      type: actions.knowledgeTypes.search,
      response: keyword,
    });
    this.props.history.push(`/search/${keyword}`);
  }
  showAutoComponent = (e, val) => {
    this.setState({
      showATC: val,
      showSearchIcon: !val,
      keyword: '',
    });
    this.props.getSearchStatus(val);
    this.props.history.push('/');
  }
  hotKeywordPannelShow = (e, f) => {
    this.setState({ hotKeywordPannelShow: f });
  }
  // 阻止冒泡
  stopPropagation = (e) => {
    e.nativeEvent.stopImmediatePropagation();
  }

  jumpTodetails = (url) => {
    if (url.indexOf(`e.qq.com${REACT_APP_ROOT_URL}`) !== -1) {
      // 如果返回的url 是内部链接直接跳转详情页面
      const aUrl = url?.split('#')[1];
      this.props.history.push(aUrl);
    } else {
      // 如果返回的H5链接直接跳转
      if (url.indexOf('http://') > -1 || url.indexOf('https://') > -1) {
        window.open(url, '_blank', 'noopener');
      } else {
        if (url.indexOf('http://') > -1) {
          window.open(`http://${url}`, '_blank', 'noopener');
        } else {
          window.open(`https://${url}`, '_blank', 'noopener');
        }
      }
    }
  }

  lookAll = (e, id) => {
    this.props.onChange(e, id);
    const { NavData } = this.props;
    const arr = NavData.filter((x) => x.catalog_id == id)[0]; // 对象
    let third = '';
    if (!arr) {
      alert('数据ID匹配不正确');
      return;
    }
    if (arr.children[0].children && arr.children[0].children.length) {
      third = arr.children[0].children[0].catalog_id;
    } else {
      third = arr.children[0].catalog_id;
    }
    this.props.history.push(`/list/article/${id}/${third}`);
    this.report(`${arr.name}-查看全部`);
  }

  report = (name) => {
    const param = {
      behavior: '点击',
      page1: '知识',
      page2: '知识库',
      page3: '首页',
      relation_name: name,
    };
    reportUserBehaviorCgi({ data: param });
  }

  jumpToSecondary = (e, pid, cid, name) => {
    const { catalog_list } = this.state;
    if (pid == 0) {
      const arr = cid.split('|');
      this.props.onChange(e, arr[0]);
      this.props.history.push(`/list/article/${`${arr[0]}/${arr[2]}`}`);
    } else {
      this.props.onChange(e, pid, cid);
      this.props.history.push(`/list/article/${`${pid}/${cid}`}`);
    }
    const obj = catalog_list.find((x) => x.catalog_id == pid) || {};
    this.report(`${obj.name}-${name}`);
  }

  render() {
    const { hot_word_list, catalog_list, newRecommendList, hotKeywordPannelShow, moreUrl = '' } = this.state;
    return (
      <div className="home" style={{ flex: 1 }}>
        <div className="help_top_container">
          <div className="help_top_section">
            <div className="help_top_left">
              <div className="help_top_left_title">服务商知识库</div>
              <h3 className="help_top_left_desc">渠道服务商的一站式知识学习平台</h3>
              <h3 className="help_top_left_desc">提供资源共享、技术赋能和精品课程，助力服务商人才培养</h3>
              <div style={{ marginTop: '72px' }} className="help_search_container">
                <div className="help_search">
                  <input
                    type="text"
                    // value={keyword}
                    onChange={this.handleSearch}
                    onKeyPress={this.handleKeyPress}
                    onClick={(e) => this.stopPropagation(e)}
                    onFocus={(e) => this.hotKeywordPannelShow(e, true)}
                    onBlur={(e) => setTimeout(() => this.hotKeywordPannelShow(e, false), 300)}
                    placeholder="请输入问题关键词进行查找"
                    className="help_input"
                  />
                  <i className="search-icon"></i>
                  <div className="help_search_option" style={{ display: `${hotKeywordPannelShow ? 'block' : 'none'}` }}>
                    <ul>
                      {hot_word_list.map((v, k) => {
                        return (
                          <li key={v} onClick={(e) => this.handleSearch(e, v, [], true)}>
                            {v}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="help_search_hot">
                  <div>搜索热词</div>
                  <div>
                    {hot_word_list.map((x) => {
                      return (
                        <span key={x} onClick={(e) => this.handleSearch(e, x, [], true)}>
                          {x}
                        </span>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="help_top_right">
              <div className="pervBg"></div>
              <div className="currentBg">
                <div className="help-bg1"></div>
                <div className="help-bg2"></div>
                <div className="help-bg3"></div>
                <div className="help-bg4"></div>
                <div className="help-bg5"></div>
                <div className="help-bg6"></div>
                <div className="help-bg7"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="help_question_container">
          <div className="help_question newlastRecommend">
            <div>
              <img style={{ verticalAlign: 'middle', marginRight: '15px' }} src={newRecommendPng} />
              最新推荐{' '}
              <span
                className="moerRecommend"
                onClick={() => {
                  this.props.history.push('/newlastRecommend');
                }}
              >
                更多&gt;&gt;
              </span>
            </div>
            <div className="help_question_section">
              <ul>
                {newRecommendList.slice(0, 3).map((x) => {
                  return (
                    <li key={x.url} onClick={(e) => this.jumpTodetails(x.url)}>
                      <span className="time">{x.publish_date}</span>
                      <span className="title">{x.title}</span>
                      {x.is_hot ? <Badge style={{ marginRight: '10px' }} count="HOT" badgeStyle={{ backgroundColor: '#E63D2E' }} /> : null}
                      {x.is_new ? <Badge count="NEW" badgeStyle={{ backgroundColor: '#e88e00' }} /> : null}
                    </li>
                  );
                })}
              </ul>
              <div>
                {newRecommendList.slice(3, 6).map((x) => {
                  return (
                    <li key={x.url} onClick={(e) => this.jumpTodetails(x.url)}>
                      <span className="time">{x.publish_date}</span>
                      <span className="title">{x.title}</span>
                      {x.is_hot ? <Badge count="HOT" style={{ marginRight: '10px' }} badgeStyle={{ backgroundColor: '#E63D2E' }} /> : null}
                      {x.is_new ? <Badge count="NEW" badgeStyle={{ backgroundColor: '#e88e00' }} /> : null}
                    </li>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="help_content_container">
          <div className="help_content">
            {catalog_list.map((x, i) => {
              let imgUrl = '';
              switch (i) {
                case 0:
                  imgUrl = 'help_content_section_adForm';
                  break;
                case 1:
                  imgUrl = 'help_content_section_adAudit';
                  break;
                case 2:
                  imgUrl = 'help_content_section_adDrop';
                  break;
                case 3:
                  imgUrl = 'help_content_section_adFlow';
                  break;
                case 4:
                  imgUrl = 'help_content_section_adDrop';
                  break;
                case 5:
                  imgUrl = 'help_content_section_adService';
                  break;
              }
              return (
                <div key={x.catalog_id} className="help_content_section">
                  <div>
                    <i className={imgUrl}></i>
                    <span>{x.name}</span>
                  </div>
                  <div>
                    {x.children.map((y) => {
                      return (
                        <span key={y.catalog_id} onClick={(e) => this.jumpToSecondary(e, x.catalog_id, y.catalog_id, y.name)}>
                          {y.name}
                        </span>
                      );
                    })}
                  </div>
                  {x.catalog_id !== 0 ? (
                    <div>
                      <span onClick={(e) => this.lookAll(e, x.catalog_id)}>查看全部</span>
                      <i className="help_content_section_all_icon"></i>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        {/* <div className="help_question_container">
          <div className="help_question">
            <div>热门文章</div>
            <div className="help_question_section">
              <div>
                {hot_post_list.slice(0, 3).map((x) => {
                  return (
                    <span key={x.post_id} onClick={(e) => this.jumpTodetails(x.post_id)}>
                      {x.title}
                    </span>
                  )
                })}
              </div>
              <div>
                {hot_post_list.slice(3, 6).map((x) => {
                  return (
                    <span key={x.post_id} onClick={() => this.jumpTodetails(x.post_id)}>
                      {x.title}
                    </span>
                  )
                })}
              </div>
              <div>
                {hot_post_list.slice(6, 9).map((x) => {
                  return (
                    <span key={x.post_id} onClick={() => this.jumpTodetails(x.post_id)}>
                      {x.title}
                    </span>
                  )
                })}
              </div>
            </div>
          </div>
        </div> */}
        <div className="help_footer_container">
          <div className="help_footer_section">
            <div className="help_footer_brand">
              <i className="help_footer_logo"></i>
              <div>{`Copyright © 1998 - ${dayjs().year()} Tencent Inc. All Rights Reserved.`}</div>
            </div>
            <div className="help_footer_msg">
              <div>
                <span>销售电话</span>
                <span>400 061 7810</span>
              </div>
              <div>
                <span>服务时间</span>
                <span>工作日 9:00-18:00</span>
              </div>
              <div>
                <span>联系邮箱</span>
                <span>ads_service@tencent.com</span>
              </div>
              <div>
                <span>微信公众号</span>
                <span>腾讯广告服务号</span>
              </div>
            </div>
            <div className="help_footer_qrcode">
              <img src={FooterQrcode} alt="腾讯广告服务号" title="腾讯社交广告服务平台" />
            </div>
          </div>
        </div>

        <div className="new-sticker">
          <ul>
            <li className="roll-top">
              <a></a>
              <div className="hover-tip">
                <div className="tip-block">返回顶部</div>
              </div>
            </li>
          </ul>
        </div>

        <div className="help_sticker show-roll">
          <ul>
            <li className="roll-top">
              <a></a>

              <div className="hover-tip">
                <div className="tip-block">返回顶部</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    navlist: state.knowledge.knowledge_list,
    catalogList: state.knowledge.knowledge_catalogList,
    catalogId: state.knowledge.knowledge_catalogId,
  };
}
export default withRouter(connect(mapStateToProps)(Home));
